// extracted by mini-css-extract-plugin
export default {"modal":"Yca-z","modalContent":"Zca-z","footer":"_ca-z","cancelBtn":"ada-z","disabled":"bda-z","formWrapper":"cda-z","fade":"dda-z","fade-in":"eda-z","iframe":"fda-z"};